import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { priceConfig } from 'modals/ShiftModal/src/views/SendToAgenciesView/RequestTeamMemberView/RequestTeamMemberViewDataProvider.constants';
import { useGQLQuery } from 'hooks';
import { UseGQLQuery } from 'hooks/useGQLQuery/useGQLQuery.types';
import { FC, useContext, useEffect } from 'react';
import { createGQLDataContext } from 'utils/createDataContext';

export const FetchMinMaxPricesByPositionIdDataContext = createGQLDataContext<{
  min: string;
  max: string;
}>(
  {} as {
    min: string;
    max: string;
  },
);

export const FetchMinMaxPricesByPositionIdDataProvider: FC = ({ children }) => {
  const { data } = useShiftModalDataContext();
  const order = data!.order;
  const { fetch, ...rest } = useGQLQuery(
    priceConfig({
      positionId: order.position.displayId || 0,
      communityId: Number(order.community.displayId),
    }),
  );

  useEffect(() => {
    if (order.position.displayId) {
      fetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FetchMinMaxPricesByPositionIdDataContext.Provider value={rest}>
      {children}
    </FetchMinMaxPricesByPositionIdDataContext.Provider>
  );
};

export const useFetchMinMaxPricesByPositionIdDataContext = (): UseGQLQuery<{
  min: string;
  max: string;
}> => useContext(FetchMinMaxPricesByPositionIdDataContext);
